import {TagRead, TagResults} from "../schemas";
import {apiFetch} from "./client";

export async function getFolders(groupId?: string, ids?: string[]): Promise<TagRead[]> {
    const params: Record<string, unknown> = {};
    if (groupId) params.group_id = groupId;
    if (ids) params.ids = ids;
    const resp = await apiFetch<TagResults>("/folders/get_folders", {params});
    return resp.tags;
}

export async function updateFolder(folderId: string, name: string, description?: string): Promise<TagRead> {
    return apiFetch<TagRead>(`/folders/${folderId}`, {
        method: "PUT",
        body: {id: folderId, name, description},
    });
}

export async function deleteFolder(folderId: string): Promise<TagRead> {
    return apiFetch<TagRead>(`/folders/${folderId}`, {method: "DELETE"});
}
